import { render, staticRenderFns } from "./CaptureScheduleSetting.vue?vue&type=template&id=5b576bd6&scoped=true&"
import script from "./CaptureScheduleSetting.vue?vue&type=script&lang=js&"
export * from "./CaptureScheduleSetting.vue?vue&type=script&lang=js&"
import style0 from "./CaptureScheduleSetting.vue?vue&type=style&index=0&id=5b576bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b576bd6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCol,VDataTable,VDatePicker,VDialog,VIcon,VMenu,VRow,VSelect,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider,VTextField,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b576bd6')) {
      api.createRecord('5b576bd6', component.options)
    } else {
      api.reload('5b576bd6', component.options)
    }
    module.hot.accept("./CaptureScheduleSetting.vue?vue&type=template&id=5b576bd6&scoped=true&", function () {
      api.rerender('5b576bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Vision/model/CaptureScheduleSetting.vue"
export default component.exports